
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form-enviado",
      function () {
        return require("private-next-pages/form-enviado.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form-enviado"])
      });
    }
  